module.exports = {
    "INTERNATIONAL_PRIORITY": {
        "delivery_day": "THU",
        "delivery_date": "2021-07-29 12:00:00",
        "price": 51.99000000000000198951966012828052043914794921875,
        "actual_price": 30,
        item_details: [],
        "delivery_message": "Thursday, Jul 29, 2021 by 12:00pm Local Time"
    },
    "INTERNATIONAL_ECONOMY": {
        "delivery_day": "FRI",
        "delivery_date": "2021-07-30 20:00:00",
        "price": 49.43999999999999772626324556767940521240234375,
        item_details: [],
        "delivery_message": "Friday, Jul 30, 2021 by 8:00pm Local Time"
    },
    "FEDEX_INTERNATIONAL_GROUND": {
        "delivery_day": "MON",
        "delivery_date": "2021-08-02 23:59:00",
        "price": 35.9500000000000028421709430404007434844970703125,
        item_details: [],
        "delivery_message": "Monday, Aug 02, 2021 by 11:59pm Local Time"
    }
};
